/**
 * Filenames Sentry should drop. The event filter compares these to the last
 * stack frame only, so the same error thrown from our bundle still reports.
 */
export const SENTRY_DENY_URLS: Array<string | RegExp> = [
  // Meta's Interactive Web Layer is injected by the Pixel Helper extension
  // and is not in our bundle.
  '/signals/iwl.js',
  // Facebook's Android in-app browser. sendDataToNative calls postMessage
  // after the Java bridge is already gone.
  'navigation_performance_logger_android',
  // Instagram's iOS in-app browser injects its native bridge at exactly
  // `app:///` (no path). That script reads `window.webkit.messageHandlers`
  // when `window.webkit` is missing. A path after the scheme can be our own
  // bundle if a webview rewrites script URLs, so only the bare filename matches.
  /^app:\/\/\/(?:[?#].*)?$/,
  // Facebook's Android in-app browser injects a declutter script at
  // `app://browser_declutter`. A SyntaxError there is that script's parser.
  // This name does not match `app:///` or `app:///_next/...`. Bare `app:///`
  // is the Instagram bridge above; a path after the scheme still reports.
  'app://browser_declutter',
];
